<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->
<div class="slds-page-header">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-icon_container"
                title="Project Import">
            <img alt="Import Projects" height="38px" src="/assets/accorto/projectImport-100.svg" width="38px">
            <span class="slds-assistive-text" i18n>Project Import</span>
          </span>
        </div>
        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span class="slds-page-header__title slds-truncate"
                      i18n i18n-title title="Project Import">Project Import
                </span>
              </h1>
            </div>
          </div>
          <p class="slds-page-header__name-meta" i18n>Import Project, Phases, and Lines from csv files</p>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="slds-is-relative">

  <!-- form -->
  <article class="slds-form slds-m-vertical_small slds-p-horizontal_small slds-card" role="list">
    <div class="slds-form__row">
      <div class="slds-form__item" role="listitem">
        <acc-form-file (fileUploaded)="onFileUploaded($event)"
                       accept="text/csv"
                       label="Import CSV File"
                       labelButton="Upload CSV"></acc-form-file>
      </div>
      <div class="slds-form__item" role="listitem">
        <div class="slds-form-element slds-m-vertical_medium">
          <div class="slds-form-element__control">
            <div class="slds-checkbox">
              <input [formControl]="importIsFirstLineHeading"
                     checked="checked" id="import-is-heading" name="import-is-heading"
                     type="checkbox"/>
              <label class="slds-checkbox__label" for="import-is-heading">
                <span class="slds-checkbox_faux"></span>
                <span class="slds-form-element__label">First line is Heading</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slds-form__row">
      <div class="slds-form__item" role="listitem">
        <div class="slds-form-element" style="width: 250px">
          <label class="slds-form-element__label" for="mapping-name">Mapping Name</label>
          <div class="slds-form-element__control">
            <input [formControl]="mappingName"
                   class="slds-input"
                   id="mapping-name" name="mapping-name" placeholder="optional name for the column mapping"
                   type="text"/>
          </div>
        </div>
      </div>
      <div class="slds-form__item" role="listitem">
        <div class="slds-form-element slds-m-vertical_medium">
          <div class="slds-form-element__control">
            <div class="slds-checkbox">
              <input [formControl]="importIsTest"
                     checked="checked" id="import-is-test" name="import-is-test"
                     type="checkbox"/>
              <label class="slds-checkbox__label" for="import-is-test">
                <span class="slds-checkbox_faux"></span>
                <span class="slds-form-element__label">Test Only</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slds-form__row">
      <div class="slds-form__item slds-m-vertical_small" role="listitem">
        <button (click)="onImportClick()"
                [disabled]="uploadDisabled"
                class="slds-button slds-button_brand" id="pi-import">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#upload"></use>
          </svg>
          Import
        </button>
      </div>
    </div>
  </article>


  <article *ngIf="showResults" class="slds-card">
    <div class="slds-m-around_small">
      <h2 class="slds-text-heading_medium">{{response.message}}</h2>
      <h3 class="slds-text-heading_small slds-text-color_error">{{response.error}}</h3>

      <div *ngIf="showResultErrors" class="slds-m-top_medium">
        <h3 class="slds-text-heading_small">Errors</h3>
        <ul class="slds-list_dotted slds-text-color_error">
          <li *ngFor="let err of response.errors">
            {{err}}
          </li>
        </ul>
      </div>

      <div *ngIf="showResultMessages" class="slds-m-top_medium">
        <h3 class="slds-text-heading_small">Messages</h3>
        <ul class="slds-list_dotted">
          <li *ngFor="let msg of response.messages">
            {{msg}}
          </li>
        </ul>
      </div>

    </div>
  </article>

  <!-- Mapping -->
  <article class="slds-card">
    <div class="slds-m-around_small">

      <div aria-labelledby="map-label"
           class="slds-form-element" role="group">
        <span class="slds-form-element__label slds-form-element__legend" id="map-label">Map CSV Columns</span>
        <div class="slds-form-element__control">
          <div class="slds-dueling-list" style="min-width: 30rem;">

            <div class="slds-dueling-list__column" style="width: 45%">
              <span class="slds-form-element__label" id="map-hdr-label">CSV Header</span>
              <div class="slds-dueling-list__options" style="width: 100%; min-width: 15rem; height: 20rem;">

                <ul aria-labelledby="map-hdr-label" aria-multiselectable="false"
                    class="slds-listbox slds-listbox_vertical" role="listbox">

                  <li (click)="onClickHeading(hdr)" *ngFor="let hdr of headingColumns"
                      class="slds-listbox__item" role="presentation">
                    <div (dragover)="onDragoverHeading($event)"
                         (drop)="onDropHeading($event, hdr)"
                         class="slds-media slds-listbox__option slds-listbox__option_entity slds-listbox__option_has-meta"
                         draggable="true"
                         role="option">
                      <span class="slds-media__figure slds-listbox__option-icon">
                        <span class="slds-icon_container">
                          <svg aria-hidden="true" class="slds-icon slds-icon_small slds-icon-text-light">
                            <use [attr.xlink:href]="href(hdr.icon ? hdr.icon : '')"></use>
                          </svg>
                        </span>
                      </span>
                      <span class="slds-media__body">
                        <span class="slds-listbox__option-text slds-listbox__option-text_entity">{{hdr.heading}}</span>
                        <span class="slds-listbox__option-meta slds-listbox__option-meta_entity">{{hdr.alias}}</span>
                      </span>
                    </div>
                  </li>

                </ul>

              </div>
            </div>

            <div class="slds-dueling-list__column" style="width: 1rem">
            </div>

            <div class="slds-dueling-list__column" style="width: 45%">
              <span class="slds-form-element__label" id="map-not-label">Available Fields</span>
              <div class="slds-dueling-list__options" style="width: 100%; min-width: 15rem; height: 20rem;">
                <ul aria-labelledby="map-not-label" aria-multiselectable="false"
                    class="slds-listbox slds-listbox_vertical" role="listbox">

                  <li (click)="onClickAvailable(col)"
                      *ngFor="let col of response.importColumns"
                      class="slds-listbox__item" role="presentation">
                    <div (dragstart)="onDragstartAvailable($event, col)"
                         class="slds-media slds-listbox__option slds-listbox__option_entity slds-listbox__option_has-meta"
                         draggable="true"
                         role="option" tabindex="0">
                      <span class="slds-media__figure slds-listbox__option-icon">
                        <span class="slds-icon_container slds-icon-standard-text">
                          <svg aria-hidden="true" class="slds-icon slds-icon_small">
                            <use [attr.xlink:href]="href(col.icon ? col.icon : '')"></use>
                          </svg>
                        </span>
                      </span>
                      <span class="slds-media__body">
                        <span class="slds-listbox__option-text slds-listbox__option-text_entity">{{col.label}}</span>
                        <span class="slds-listbox__option-meta slds-listbox__option-meta_entity">{{col.alias}}</span>
                      </span>
                    </div>
                  </li>

                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="slds-form-element">
        <label class="slds-form-element__label" for="mapping-infos">Mapping Infos</label>
        <div class="slds-form-element__control">
          <textarea [formControl]="mappingInfos"
                    class="slds-textarea"
                    id="mapping-infos"></textarea>
        </div>
      </div>

    </div>
  </article>


  <article *ngIf="showTable"
           class="slds-card">
    <div class="slds-m-around_small slds-scrollable_x">

      <table class="slds-table slds-table_cell-buffer slds-table_bordered slds-table_col-bordered">
        <thead>
        <tr class="slds-line-height_reset">
          <th class="slds-align-top" scope="col">#</th>
          <th *ngFor="let hc of response.headingColumns"
              [title]="hc.alias" class="slds-align-top"
              scope="col">
            <div class="slds-text-font_monospace">{{hc.heading}}</div>
            <div class="slds-text-color_success" class="manual-hyphens">
              <small>{{printAlias(hc.alias)}}</small>
            </div>
          </th>
        </tr>
        </thead>

        <tbody>
        <ng-container *ngFor="let row of response.rows">
          <tr class="slds-hint-parent slds-text-font_monospace">
            <td>{{row.rowNo}}</td>
            <td *ngFor="let cell of row.cells">
              {{cell}}
            </td>
          </tr>

          <tr class="slds-align-top">
            <td></td>
            <td [colSpan]="colspan1">
              <ul class="slds-list_dotted">
                <li *ngFor="let msg of row.messages">
                  <div *ngIf="msg.startsWith('SUCCESS')" class="slds-text-color_success">
                    <span class="import-row-msg">{{cleanMsg(msg)}}</span>
                  </div>
                  <div *ngIf="msg.startsWith('ERROR')" class="slds-text-color_error">
                    <span class="import-row-msg">{{cleanMsg(msg)}}</span>
                  </div>
                  <div *ngIf="!msg.startsWith('SUCCESS') && !msg.startsWith('ERROR')">
                    <span class="import-row-msg">{{cleanMsg(msg)}}</span>
                  </div>
                </li>
              </ul>
            </td>
            <td [colSpan]="colspan2">
              <ul class="slds-list_dotted">
                <!--suppress TypeScriptValidateTypes -->
                <li *ngFor="let item of row.valueMap | keyvalue">
                  <span>{{item.key}}: {{item.value}}</span>
                </li>
              </ul>
            </td>
          </tr>
        </ng-container>
        </tbody>

      </table>
    </div>
  </article>

  <acc-spinner *ngIf="busy" message="importing..."></acc-spinner>

</section>
